import { render, staticRenderFns } from "./IconAddMenuLinear.vue?vue&type=template&id=6d2443c0&scoped=true"
import script from "./IconAddMenuLinear.vue?vue&type=script&lang=js"
export * from "./IconAddMenuLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2443c0",
  null
  
)

export default component.exports